import { render, staticRenderFns } from "./DocumentsRecivedDgii.vue?vue&type=template&id=ded74952"
import script from "./DocumentsRecivedDgii.vue?vue&type=script&lang=js"
export * from "./DocumentsRecivedDgii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports